import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
  bindAngularDependenciesToCoreAndMapToAngularProvider,
  coreDependenciesToAngularProviderMapper,
} from '@di/angularProviderMapper';
import { Kernel } from '@di/kernel';
import { buildConfiguration } from '@di/kernelConfiguration';
import { InitModule } from '@modules/init/init.module';
import { ProcessModule } from '@modules/process/process.module';
import { RedirectToExternalBankModule } from '@modules/redirect-to-external-bank/redirect-to-external-bank.module';
import { WebauthPopupModule } from '@modules/webauth-popup/webauth-popup.module';
import { SharedModule } from '@shared/shared.module';
import { NgxTagCommanderModule, WindowRef } from 'ngx-tag-commander';
import { ErrorModule } from '@modules/error/error.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { CacheInterceptor } from './core/interceptor/cache-interceptor';

const kernelConfiguration = buildConfiguration();
const kernel = Kernel.initialize(kernelConfiguration);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ProcessModule,
    WebauthPopupModule,
    RedirectToExternalBankModule,
    SharedModule,
    CoreModule,
    InitModule,
    ErrorModule,
    CommonModule,
    NgxTagCommanderModule,
    HttpClientModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
    WindowRef,
    coreDependenciesToAngularProviderMapper(kernel),
    bindAngularDependenciesToCoreAndMapToAngularProvider(kernel),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
